<template>
  <div class="overflow-auto">
    <div class="line-header-wrapper">
      <div class="month-name-text month-name-text-space">
        {{ 'Month' | i18n }}
      </div>
      <div class="number-text">
        {{ 'Ist Wärmelieferung' | i18n }}
      </div>
      <div class="number-input">
        {{ 'Abrechnung RE' | i18n }}
      </div>
      <div class="number-text">
        {{ 'Ist Strombezug' | i18n }}
      </div>
      <div class="number-input">
        {{ 'Abrechnung RE' | i18n }}
      </div>
      <div class="number-text">
        {{ 'Ist Stromlieferung 25kV' | i18n }}
      </div>
      <div class="number-input">
        {{ 'Abrechnung RE' | i18n }}
      </div>
      <div class="number-text">
        {{ 'Ist Stromlieferung 110kV' | i18n }}
      </div>
      <div class="number-input">
        {{ 'Abrechnung RE' | i18n }}
      </div>
    </div>
    <div v-for="(line, key) in monthlyData" :key="line.nameOfMonth" class="line-wrapper">
      <div class="month-name-text mt-3">
        {{ line.nameOfMonth | i18n }}
      </div>
      <div class="number-text mt-3">
        {{ line['Ist Wärmelieferung'] }}
      </div>
      <div class="number-input">
        <Input
          :value="modifiedData[key]['Ist Wärmelieferung']"
          :on-change="(v) => setModifiedData(v, 'Ist Wärmelieferung', key)"
          form-group-id="IstWärmelieferung"
          placeholder=""
          type="number"
          :bottom="0"
        />
      </div>
      <div class="number-text mt-3">
        {{ line['Ist Strombezug'] }}
      </div>
      <div class="number-input">
        <Input
          :value="modifiedData[key]['Ist Strombezug']"
          :on-change="(v) => setModifiedData(v, 'Ist Strombezug', key)"
          form-group-id="IstStrombezug"
          placeholder=""
          type="number"
          :bottom="0"
        />
      </div>
      <div class="number-text mt-3">
        {{ line['Ist Stromlieferung 25kV'] }}
      </div>
      <div class="number-input">
        <Input
          :value="modifiedData[key]['Ist Stromlieferung 25kV']"
          :on-change="(v) => setModifiedData(v, 'Ist Stromlieferung 25kV', key)"
          form-group-id="IstStromlieferung25kV"
          placeholder=""
          type="number"
          :bottom="0"
        />
      </div>
      <div class="number-text mt-3">
        {{ line['Ist Stromlieferung 110kV'] }}
      </div>
      <div class="number-input">
        <Input
          :value="modifiedData[key]['Ist Stromlieferung 110kV']"
          :on-change="(v) => setModifiedData(v, 'Ist Stromlieferung 110kV', key)"
          form-group-id="IstStromlieferung110kV"
          placeholder=""
          type="number"
          :bottom="0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Input from '../../common/input';

export default {
  title: 'Energiewerte Lines',
  components: { Input },
  props: {
    monthlyData: {
      type: Object,
      default: () => {},
    },
    modifiedData: {
      type: Object,
      default: () => {},
    },
    setModifiedData: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
.line-header-wrapper {
  display: flex;
  background: rgb(247, 247, 249);
  position: sticky;
  top: 0;
  z-index: 1000;
  div {
    display: flex;
    align-items: center;
    background: #f7f7f9;
  }
}

.line-wrapper {
  display: flex;
}

.number-input {
  min-width: 95px;
  flex: 1;
  padding: 0 5px;
  max-width: 150px;
}

.number-text {
  min-width: 100px;
  padding: 0 5px;
  text-align: center;
  justify-content: center;
  flex: 1;
}

.month-name-text {
  min-width: 75px;
  width: 75px;
  padding: 0px 5px;
}

.month-name-text-space {
  padding: 10px 5px;
}
</style>
